export const captchaToken = process.env.REACT_APP_GOOGLE_CAPTCHA_PUBLIC_KEY || window._env_.GOOGLE_CAPTCHA_PUBLIC_KEY;